export default {
    methods: {
        safeRedirect: function (path) {
            window.location.href = this.$config.ROOT_URL + (path ?? '/')
        },
    }
}
